import React, { memo } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';

import SubmitBtn from '@/pages/reservation/roomExchange/components/SubmitBtn';

import { createStateSelector } from '@/redux/actions/reservation/helper';
import { ReducerState, storeName } from '@/redux/reducers/reservation/reserveExchange';

const stateSelector = (state: ReducerState) => {
  const { rentRoomInfos, marketPriceList, rentTimeInfo } = state;
  return { rentRoomInfos, marketPriceList, rentTimeInfo };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;
interface IProps {
  onSubmit: () => void;
}

const Index: React.FC<IProps & MapStateProps & MapDispatchProps> = (props) => {
  const { onSubmit, rentRoomInfos, marketPriceList } = props;

  return (
    <SubmitBtn
      btnText={intl.get('drawer_exchange_reserve_submit_btn')}
      onSubmit={onSubmit}
      rentRoomInfos={rentRoomInfos}
      marketPriceList={marketPriceList}
      storeRemarks={{
        changeReason: '其他',
        changeReasonCode: 'QT',
        changeDetail: '其他原因', // 随便的文案 满足三个字符且必须一个汉字的要求就行
      }} // // 预订换排房临时写死
    />
  );
};

export default connect<MapStateProps, MapDispatchProps, IProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
